import { render, staticRenderFns } from "./Jira.vue?vue&type=template&id=3fd454f4&scoped=true&"
import script from "./Jira.vue?vue&type=script&lang=js&"
export * from "./Jira.vue?vue&type=script&lang=js&"
import style0 from "./Jira.vue?vue&type=style&index=0&id=3fd454f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd454f4",
  null
  
)

export default component.exports